import { useEffect, useState, useRef } from 'react';
import { isEqual } from "lodash";
import useQuery from 'hooks/useQuery';

export default function useAppState(){
    const query = useQuery()

    const [ activeCompany, setActiveCompany ] = useState()
    const [ loaded, setLoaded ] = useState(false)
    const [ identity, setIdentity ] = useState(false)
    const [ site_section ] = useState(window.location.pathname.split("/").filter(Boolean).pop())
    const [ domain ] = useState(window.location.host.split(':')[0])
    const [ explorerViewAllowed, setExplorerViewAllowed ] = useState(null)
    const [ explorerEditAllowed, setExplorerEditAllowed ] = useState(null)

    function updateActiveCompany(company) {
        if (company) {
            localStorage.setItem("am:audience:active:company", JSON.stringify(company))
            setActiveCompany(company)
        }
    }

    function userCan(perm, user) {
      if(perm === 'has_explorer_view') {
        return explorerViewAllowed;        
      }
      if(perm === 'has_explorer_edit') {
        return explorerEditAllowed;        
      }

      const perms = (user) ? user.permissions : identity?.user?.permissions || [];
      let access = perms.find((p) => p.name === perm);
      if (access) {
          return true;
      } else {
          return false;
      }
    }

    function loadIdentity() {
      query('users/current-identity').then(
          //success
          (response)=> {
              setIdentity(response)
              let storedCompany = JSON.parse(localStorage.getItem("am:audience:active:company") || "{}")

              // check if user has access to stored company: if not: don't use stored company
              if(Object.keys(storedCompany).length > 0) {
                let has_access = [];
                response.assigned_companies.forEach((_company) => {
                  has_access.push(_company.id);
                })
                if(!has_access.includes(storedCompany.id)) {
                  storedCompany = {};
                }
              }

              const company = storedCompany && storedCompany.id 
                              ? response.assigned_companies.find(c => c.id === storedCompany.id)
                              : response.assigned_companies[0];
              updateActiveCompany(company)
              setLoaded(true)
          },
          //failure
          ()=> {
              setIdentity(null)
              setLoaded(true)
      })
    }

    // eslint-disable-next-line
    const appState = {
        loaded: loaded,
        identity: identity,
        site_section: site_section,
        domain: domain,
        activeCompany: activeCompany,
        updateActiveCompany,
        userCan,
        refreshIdentity: loadIdentity,
    }
    const previousValue = useRef(appState);

  useEffect(() => {
    const perms = identity?.user?.permissions;
    if (!perms) { return; }

    const current_explorer_module = localStorage.getItem("am:explorer_module") || "consumers";

    const modulePermMap = {
        consumers: { view: 'explorer_consumers_view', edit: 'explorer_consumers_edit' },
        movers: { view: 'explorer_movers_view', edit: 'explorer_movers_edit' },
        life_events: { view: 'explorer_lifeevents_view', edit: 'explorer_lifeevents_edit' },
    };

    // Explorer section visible if user has access to ANY module
    const hasAnyExplorerView = Object.values(modulePermMap).some(
        ({ view }) => perms.some((p) => p.name === view)
    );
    setExplorerViewAllowed(hasAnyExplorerView);

    // Explorer edit based on current active module only
    const modulePerms = modulePermMap[current_explorer_module];
    if (modulePerms) {
        setExplorerEditAllowed(perms.some((p) => p.name === modulePerms.edit));
    }
  }, [identity]);

    useEffect( ()=> {
      loadIdentity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        let has_changes = false;
        
        if( !isEqual(appState.activeCompany, previousValue.current.activeCompany) ) {
          has_changes = true;
        }
        if( !isEqual(appState.identity, previousValue.current.identity) ) {
          has_changes = true;
        }
        if( !isEqual(appState.site_section, previousValue.current.site_section) ) {
          has_changes = true;
        }
        if( !isEqual(appState.loaded, previousValue.current.loaded) ) {
          has_changes = true;
        }

        if(has_changes) {
          previousValue.current = appState;
        }
        
        // eslint-disable-next-line
      }, [appState]);

  return appState;
}
